import React, { useContext } from 'react';
import './Contact.css';
import { UserContext } from '../../../App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import facebook from '../../../images/social/facebook.png';
import linkedIn from '../../../images/social/linkedin.png';
import email from '../../../images/social/mail.png';
import twitter from '../../../images/social/twitter.png';
import github from '../../../images/social/github.png';
import emailjs from 'emailjs-com';
import SnackBarUi from '../../MaterialUI/SnackBarUi';

const Contact = () => {
    const [cardDisplay, setCardDisplay, authentication, setAuthentication, snackBarUI, setSnackBarUI, backdropUI, setBackdropUI] = useContext(UserContext);

    const sendEmail = (event) => {
        event.preventDefault();

        emailjs.sendForm('service_c7cckvd', 'template_che72ek', event.target, 'user_MdxD8DI2gI0LLKukZrqGP')
            .then((result) => {
                setSnackBarUI({
                    state: true,
                    severity: 'success',
                    message: 'Your email has been sent successfully!'
                })
            }, (error) => {
                setSnackBarUI({
                    state: true,
                    severity: 'error',
                    message: 'There is a problem sending email!'
                })
            });
    }

    const fbLink = 'https://www.facebook.com/naim.morshed.1/';
    const linLink = 'https://www.linkedin.com/in/naim-morshed-3a30b8178/';
    const gitLink = 'https://github.com/NaimMorshed';
    const tweetLink = 'https://twitter.com/naimpritom';

    return (
        <div id="contact">
            <div className="App container-work">
                <div className="center container">
                    <h1 className="h1-sec">Contact Me</h1>
                    <hr className="hr-sec" />
                    <br />
                    <p className="transparent-text">Hey boss, are you looking for a cooking master? I am ready to be hired.</p>
                    <br /><br />
                    <section className="contact-section">
                        <form onSubmit={sendEmail} className="contact-form">
                            <input className="input" type="text" name="name" placeholder="Enter your name" required />
                            <input className="input" type="email" name="email" placeholder="Enter your email" required />
                            <input className="input-lg" type="text" name="message" placeholder="Enter your message here" required />
                            <br />
                            <input className="btn btn-outline-light btn-msg" type="submit" value="SEND MESSAGE" />
                        </form>
                        <hr className="form-hr" />
                        <h4 className="text-light">Find me on social <FontAwesomeIcon className="icon-color ml-2 text-light" icon={faLongArrowAltRight} /></h4>
                        <div className="social-white">
                            <a href={fbLink} target="_blank"><img src={facebook} alt="" /></a>
                            <a href={linLink} target="_blank"><img src={linkedIn} alt="" /></a>
                            <a href="mailto:morshed.naim13@gmail.com" target="_blank"><img src={email} alt="" /></a>
                            <a href={tweetLink} target="_blank"><img src={twitter} alt="" /></a>
                            <a href={gitLink} target="_blank"><img src={github} alt="" /></a>
                        </div>
                        <SnackBarUi />
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Contact;